/* eslint-disable postro4no/object-props */
export const teamSelectedParams = [
  {
    checked: true, groupe: 'main', id: 0, label: 'Goals', lexic_id: 102, shortName: 'GS',
  },
  {
    checked: true, groupe: 'main', id: 1, label: 'Assists', lexic_id: 105, shortName: 'AST',
  },
  {
    checked: true, groupe: 'main', id: 2, label: 'Goals conceded', lexic_id: 318, shortName: 'GC',
  },
  {
    checked: true, groupe: 'main', id: 3, label: 'Mistakes', lexic_id: 17, shortName: 'M',
  },
  {
    checked: true, groupe: 'main', id: 4, label: 'Yellow cards', lexic_id: 104, shortName: 'YC',
  },
  {
    checked: true, groupe: 'main', id: 5, label: 'Red cards', lexic_id: 103, shortName: 'RC',
  },
  {
    checked: true, groupe: 'main', id: 6, label: 'Goal mistakes', lexic_id: 324, shortName: 'GM',
  },
  {
    checked: true, groupe: 'main', id: 7, label: 'Offsides', lexic_id: 83, shortName: 'OFF',
  },
  {
    checked: true, groupe: 'main', id: 8, label: 'On-ball events', lexic_id: 326, shortName: 'OBE',
  },
  {
    checked: true, groupe: 'main', id: 9, label: 'On-ball events +', lexic_id: 326, shortName: 'OBE+', symbol: '+',
  },
  {
    checked: true, groupe: 'main', id: 10, label: 'On-ball events, %', lexic_id: 326, shortName: 'OBE%', symbol: '%',
  },
  {
    checked: true, groupe: 'main', id: 11, label: 'Fouls', lexic_id: 328, shortName: 'F',
  },
  {
    checked: true, groupe: 'shots', id: 12, label: 'Shots', lexic_id: 18, shortName: 'SH',
  },
  {
    checked: true, groupe: 'shots', id: 13, label: 'Shots on post or bar', lexic_id: 34, shortName: 'SHPB',
  },
  {
    checked: true, groupe: 'shots', id: 14, label: 'Shots on target', lexic_id: 37, shortName: 'SH+',
  },
  {
    checked: true, groupe: 'shots', id: 15, label: 'Shots on target, %', lexic_id: 37, shortName: 'SH%', symbol: '%',
  },
  {
    checked: true, groupe: 'shots', id: 16, label: 'Shots wide', lexic_id: 33, shortName: 'SHW',
  },
  {
    checked: true, groupe: 'ball movement', id: 17, label: 'Key passes', lexic_id: 330, shortName: 'KP',
  },
  {
    checked: true, groupe: 'ball movement', id: 18, label: 'Key passes +', lexic_id: 330, shortName: 'KP+', symbol: '+',
  },
  {
    checked: true, groupe: 'ball possession', id: 19, label: 'Ball interceptions', lexic_id: 335, shortName: 'BI',
  },
  {
    checked: true, groupe: 'ball possession', id: 20, label: 'Ball interceptions +', lexic_id: 335, shortName: 'BI+', symbol: '+',
  },
  {
    checked: true, groupe: 'ball possession', id: 21, label: 'Ball losses', lexic_id: 336, shortName: 'BL',
  },
  {
    checked: true, groupe: 'ball possession', id: 22, label: 'Ball recoveries', lexic_id: 337, shortName: 'BR',
  },
  {
    checked: true, groupe: 'ball possession', id: 23, label: 'Neutral ball recoveries', lexic_id: '', shortName: 'NBR',
  },
  {
    checked: true, groupe: 'duels', id: 24, label: 'GS opportunities', lexic_id: 84, shortName: 'GSO',
  },
  {
    checked: true, groupe: 'duels', id: 25, label: 'GS opportunities +', lexic_id: 84, shortName: 'GS+',
  },
  {
    checked: true, groupe: 'duels', id: 26, label: 'GS opportunities +, %', lexic_id: 84, shortName: 'GS%', symbol: '%',
  },
  {
    checked: true, groupe: 'duels', id: 27, label: 'Duels', lexic_id: 20, shortName: 'D',
  },
  {
    checked: true, groupe: 'duels', id: 28, label: 'Duels +', lexic_id: 20, shortName: 'D+', symbol: '+',
  },
  {
    checked: true, groupe: 'duels', id: 29, label: 'Duels +, %', lexic_id: 20, shortName: 'D%', symbol: '+, %',
  },
  {
    checked: true, groupe: 'duels', id: 30, label: 'Aerial duels', lexic_id: 60, shortName: 'AD',
  },
  {
    checked: true, groupe: 'duels', id: 31, label: 'Aerial duels +', lexic_id: 331, shortName: 'AD+', symbol: '+',
  },
  {
    checked: true, groupe: 'duels', id: 32, label: 'Aerial duels +, %', lexic_id: 331, shortName: 'AD%', symbol: '+, %',
  },
  {
    checked: true, groupe: 'duels', id: 33, label: 'Tackles', lexic_id: 61, shortName: 'T',
  },
  {
    checked: true, groupe: 'duels', id: 34, label: 'Tackles +', lexic_id: 61, shortName: 'T+', symbol: '+',
  },
  {
    checked: true, groupe: 'duels', id: 35, label: 'Dribbles past opponent', lexic_id: 332, shortName: 'DPO',
  },
  {
    checked: true, groupe: 'duels', id: 36, label: 'Dribbles past opponent +', lexic_id: 332, shortName: 'DPO+', symbol: '+',
  },
  {
    checked: true, groupe: 'duels', id: 37, label: 'Dribbles past opponent +, %', lexic_id: 332, shortName: 'DPO%', symbol: '+, %',
  },
]
